import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {Button, Typography} from "@mui/material";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";
import PatternsController from "../../../API/organization/PatternsController";
import DetailTable from "../../../components/UI/table/cutting/details/DetailTable";
import VariablesTable from "../../../components/UI/table/customer-detales/processing/VariablesTable";
import {withFilter} from "../../../data/FilterTables/withFilterHOC";
import {VariablesFilterData} from "../../../data/FilterTables/VariablesFilterData";
import {DetailFilterData} from "../../../data/FilterTables/DetailFilterData";
import CircularProgress from "@mui/material/CircularProgress";
import RelateDetailsTable from "./RelateDetailsTable";
import {RelateDetailsFilterData} from "../../../data/FilterTables/RelateDetailsFilterData";

const PatternsItem = () => {
    const ComponentDetailWithFilter = useMemo(() => {
        return withFilter(DetailTable, DetailFilterData);
    }, []);
    const ComponentVariablesWithFilter = useMemo(() => {
        return withFilter(VariablesTable, VariablesFilterData);
    }, []);
    const ComponentRelateWithFilter = useMemo(() => {
        return withFilter(RelateDetailsTable, RelateDetailsFilterData);
    }, []);
    const {moduleId, moduleName, id, name} = useParams();
    const pathname = useLocation().pathname
    const [loading, setLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const [data, setData] = useState({
        details: [],
        id: 2,
        patternL: null,
        patternW: null,
        relateDetails: {},
        variablesMap: {}
    });
    const [variables, setVariables] = useState([])
    const [relateDetails, setRelateDetails] = useState([])
    const [patternName, setPatternName] = useState(name)
    const navigate = useNavigate();
    const [alertData, setAlertData] = useState({});
    const [tab, setTab] = useState(1);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = pagesData[pathname]?.tab || 1

        return {savedTab}
    }

    useEffect(() => {
        const {savedTab} = getStartPageSize()
        PatternsController.getById(moduleId, id).then(function (response) {
            const data = response.data
            const variables = data.variablesMap
            const relate = data.relateDetails
            setData(data);
            setVariables(Object.values(variables))
            setRelateDetails(Object.values(relate))
            setTab(savedTab)
            tableOptionsHandle((prev) => ({
                ...prev,
                totalElements: savedTab === 2 ? variables.length : savedTab === 4 ? relate.length : data.details.length
            }))
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setIsLoading(false))
    }, []);

    const handleChangeTab = (tab) => {
        setTab(tab)
        tableOptionsHandle((prev) => ({
            ...prev,
            totalElements: tab === 2 ? variables.length : tab === 4 ? relateDetails.length : data.details.length
        }))
        EditLocalStoragePagesData(pathname, "tab", tab)
    }

    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleUpdate = () => {
        setLoading(true)
        PatternsController.update(replaceEmptyStringsOnNull({
            name: patternName,
            patternL: data.patternL,
            patternW: data.patternW
        }), moduleId, id)
            .then(function (response) {
                navigate('/organization/module/' + moduleId + '/' + moduleName + '/patterns/' + response.data.id + "/" + response.data.name)
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }
    const setDetail = (newData) => {
        setData(prev => ({...prev, details: newData}))
    }

    const generalTabComponents = [
        {
            tabIndex: 1, label: "Основные",
            component: <Box sx={{width: "400px"}}>
                <TextFieldValidation
                    name={"name"}
                    type={"text"}
                    value={patternName}
                    label={"Наименование"}
                    setCurrValues={(getData) => setPatternName(getData().name)}
                    required={false}
                />
                <TextFieldValidation
                    name={"patternL"}
                    type={"text"}
                    value={data?.patternL}
                    label={"Паттерн длины"}
                    setCurrValues={setData}
                    required={false}
                />
                <TextFieldValidation
                    name={"patternW"}
                    type={"text"}
                    value={data?.patternW}
                    label={"Паттерн ширины"}
                    setCurrValues={setData}
                    required={false}
                />
                <Box sx={{
                    width: 400,
                    paddingTop: "20px",
                    display: "flex",
                    justifyContent: data ? "flex-end" : "flex-start"
                }}>
                    <ButtonAdd loading={loading} text={"Применить"} onClick={handleUpdate}/>
                </Box>
            </Box>
        },
        {
            tabIndex: 2, label: "Переменные",
            component: <ComponentVariablesWithFilter
                data={variables}
                setData={setVariables}
                enableEditing={true}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                patterns={true}
                moduleId={moduleId}
                detailPatternId={id}
            />
        },
        {
            tabIndex: 3, label: "Детали",
            component:
                <ComponentDetailWithFilter
                    data={data.details}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    setData={setDetail}
                    handleModalAlert={handleModalAlert}
                    isColumnMaterial={false}
                    isColumnOrder={false}
                    isDetailModel={false}
                    isButtonAddDetail={false}
                    expanded={false}
                    enableEditing={true}
                    viewingAvailable={true}
                    isPattern={true}
                    moduleId={moduleId}
                    patternId={id}
                />
        },
        {
            tabIndex: 4, label: "Зависимости",
            component: <ComponentRelateWithFilter
                handleModalAlert={handleModalAlert}
                moduleId={moduleId}
                patternId={id}
                data={relateDetails}
                setData={setRelateDetails}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
            />
        },]
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Паттерн ${name}`}
                path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}, {
                    name: `Модуль ${moduleName}`,
                    href: `/organization/module/${moduleId}`
                }]}/>
            {isLoading ?
                <Box sx={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress disableShrink/>
                </Box> : <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                    <Typography
                        sx={{fontSize: "24px", fontWeight: 700}}>{`Паттерн ${name} модуля ${moduleName}`}</Typography>
                    <ButtonGroupTabBar activeTab={tab}>
                        {generalTabComponents.map(({tabIndex, label}, index) => {
                            return <Button key={tabIndex} tabIndex={tabIndex} onClick={() => handleChangeTab(tabIndex)}>
                                <CheckIcon/>
                                {label}
                            </Button>
                        })}
                    </ButtonGroupTabBar>
                    {generalTabComponents.find(component => component.tabIndex === tab)?.component}
                </Box>}
            <ModalAlert
                data={alertData}
                onClose={handleCloseAlert}/>
        </Box>
    );
}
export default PatternsItem